<div class="drawer-content">
  <header class="title-area">
    <app-titulo [titulo]="titulo" [subtitulo]="subtitulo()"></app-titulo>
    <mat-icon
      class="close-icon"
      aria-hidden="false"
      aria-label="Example home icon"
      fontIcon="close"
      (click)="cancelar()"></mat-icon>
  </header>
  @if (modalFormService.showingModal | async) {
    <div class="form-area">
      <app-form-crear-area
        #form
        (successChange)="onSuccessChange($event)"
        (areaCreated)="onAreaCreated($event)"
        (submitError)="onSubmitError($event)"></app-form-crear-area>
    </div>
  }
  <div class="bottom-area">
    <div class="actions">
      @if (!isSuccess()) {
        <app-button-primary
          class="button"
          (clicked)="guardar()"
          [disabled]="disabledButton"
          [spinner]="isLoading()"
          width="100%"
          [label]="labelPrimaryButton()">
        </app-button-primary>
      }
      <app-button-secondary
        class="button"
        [disabled]="false"
        (clicked)="cancelar()"
        width="100%"
        [label]="labelSecondaryButton()">
      </app-button-secondary>
    </div>
    <app-error-message [showError]="error()" [error]="error()">
    </app-error-message>
  </div>
</div>
